import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { filter } from 'rxjs/operators';

import { Audit, AuditStatus } from '../../audit.model';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { AuditEditDialogComponent } from '../audit-edit-dialog/audit-edit-dialog.component';
import { BreadcrumbItem, RequestResult } from '../../../shared/shared.model';
import { AuditService } from '../../audit.service';
import { OkCancelDialogComponent } from '../../../shared/components/ok-cancel-dialog/ok-cancel-dialog.component';

@Component({
  selector: 'iaud-audit-details',
  templateUrl: './audit-details.component.html',
  styleUrls: ['./audit-details.component.scss'],
})
export class AuditDetailsComponent implements OnInit {
  audit: Audit;
  dateFormat: string = DISPLAY_DATE_FORMAT;
  auditStatus = AuditStatus;
  canUpdate : boolean;   
  hasHistory : boolean; 
  isCompleted : boolean;

  breadcrumbs: Array<BreadcrumbItem> = [
    {
      title: 'Home',
      path: '/home',
    },
    {
      title: 'All audits',
      path: '/audit',
    },
  ];
  reloadFinding: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private auditService: AuditService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.audit = this.route.snapshot.data.audit;

    this.canUpdate = this.audit.canUpdate;      
    this.hasHistory = (this.audit.history=="" || this.audit.history==null)? false:true; 
    
    this.isCompleted = false;
    if(this.audit.status.toLowerCase() == "completed"){
      this.isCompleted =true;
    }
    
    this.breadcrumbs.push({
      title: `Audit: ${this.audit.auditTitle || '[no title]'}`,
      path: `/audit/${this.audit.id}`,
    });
  }

  editAudit(): void {
    const dialogRef = this.dialog.open(AuditEditDialogComponent, { data: { audit: this.audit } });

    dialogRef.afterClosed()
      .pipe(
        filter(res => res && res.success)
      )
      .subscribe(res => {
        this.auditService.getAudit(res.audit)
          .subscribe(o => this.audit = o);
      });
  }

  showAuditHistory(): void {
    this.router.navigateByUrl(`/audit/history/${this.audit.id}`);    
  }  

  submitAudit(): void {
    if (!(this.audit.canSubmit === true)) {
      return;
    }
    const dlgData = {
      data: {
        title: 'Are you sure you want to submit entire Audit?',
        text: '',
        okText: 'Submit',
      },
    };
    if (this.audit.draftFindingCount === 0) {
      dlgData.data.text =
        `<b>${this.audit.auditTitle}</b> audit and <b>${this.audit.findingCount} Findings</b> \
         and <b>${this.audit.capaCount} CAPA/ECs</b> are about to be submitted. \
        <br>You can't undo this action`;
    } else {
      dlgData.data.text = `<b>${this.audit.draftFindingCount}/${this.audit.findingCount} Findings are draft!</b><br><br> \
        <b>${this.audit.auditTitle}</b> audit and <b>${this.audit.findingCount} Findings</b> \
        and <b>${this.audit.capaCount} CAPA/ECs</b> are about to be submitted. \
        <br>You can't undo this action`;
    }
    const dialogRef = this.dialog.open(OkCancelDialogComponent, dlgData);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.auditService.submitEntireAudit(this.audit.id)
          .subscribe((res: RequestResult) => {
            if (res.success) {
              this.reloadFinding.emit(true);
              this.auditService.getAudit(this.audit.id)
                .subscribe(o => this.audit = o);
            }
          });
      }
    });
  }
}
